import { useState, useEffect, useContext } from 'react'
import MenuPanel from 'components/Menu/MenuPanel'
import GlobalStyles from 'components/GlobalStyles'
import Footer from 'components/Layout/Footer'
import Header from 'components/Layout/Header'
import { LayoutContext, HomeDispatchContext } from 'utils/contextUtils'
import { MainWrapper, HeaderContainer } from './LayoutStyles.js'

const Layout = ({ children, headerItems, setShowFilters }) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [showHomeOverlay, setShowHomeOverlay] = useState(() => {
    if (typeof sessionStorage === 'undefined') {
      return true
    }
    if (sessionStorage.getItem('showHomeOverlay') === null) {
      return true
    }
    return sessionStorage.getItem('showHomeOverlay') === 'true'
  })
  const dispatch = useContext(HomeDispatchContext)

  useEffect(() => {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('showHomeOverlay', showHomeOverlay)
    }
    if (showHomeOverlay) {
      if (dispatch) { dispatch({ type: 'clearFilters' }) }
      if (setShowFilters) { setShowFilters(false) }
    }
  }, [showHomeOverlay, dispatch, setShowFilters])

  return (
    <LayoutContext.Provider value={{ showHomeOverlay, setShowHomeOverlay }}>
      <MainWrapper>
        <GlobalStyles />
        <header>
          <HeaderContainer>
            <Header setMenuOpen={setMenuOpen} />
            <MenuPanel open={menuOpen} setOpen={setMenuOpen} />
            {headerItems}
          </HeaderContainer>
        </header>
        <main>
          {children}
        </main>
        <footer>
          <Footer />
        </footer>
      </MainWrapper>
    </LayoutContext.Provider>
  )
}

export default Layout
